window.onunload = function () {};

let hasUnsavedChanges = false;


window.shadow_host_web_pages = function () {
  const hosts = document.querySelectorAll(".shadow-container");

  hosts.forEach(host => {
  const shadow = host.attachShadow({ mode: 'open' });

  const backgroundColor = host.dataset.backgroundColor || "#fff";
  const htmlContent = host.dataset.bodyHtml || "";

  shadow.innerHTML = `
    <style>
        :host {
        all: initial;
        }
        .content-body {
        padding: 0.5rem;
        background-color: ${backgroundColor};
        font-family: sans-serif;
        color: #000;
        zoom: 0.5;
        height: 1000px;
        overflow: hidden;
        }
    </style>
    <div class="content-body">${htmlContent}</div>
  `;
  });
}

window.initializeSelect2Elements = function (elements) {
  elements.each(function() {
    $(this).select2({
      theme: 'bootstrap-5',
      dropdownParent: $(this).parent(),
      placeholder: $(this).data('placeholder') || 'Select options',
      width: '100%'    
    });
  });
}
//Nested fields select2
$(document).on('cocoon:after-insert', function(e, insertedItem) {
  if(insertedItem.hasClass('cf-condition')){
    insertedItem.parent().find('.cf-condition').first().find('.cf-logic').css('display', 'none')
  }
  if(insertedItem.hasClass('cf-condition-block')){
    insertedItem.parent().find('.cf-condition-block').first().find('.cf-group-logic').css('display', 'none')
  }
  const selectElements = insertedItem.find('.initialize-on-insert');
  initializeSelect2Elements(selectElements);
});

$(document).on('cocoon:before-remove', function(e, el_to_remove) {

  if (!confirm("Are you sure?")) {
    e.preventDefault();
  }else{
    if(el_to_remove.hasClass('cf-condition')){
      el_to_remove.removeClass('cf-condition')
      el_to_remove.parent().find('.cf-condition').first().find('.cf-logic').css('display', 'none')
    }
  
    if(el_to_remove.hasClass('cf-condition-block')){
      el_to_remove.removeClass('cf-condition-block')
      el_to_remove.parent().find('.cf-condition-block').first().find('.cf-group-logic').css('display', 'none')
    }
  }

});

window.start_loading_animation_M = function() {
    $('body').addClass('wait');
    $(".loader-wrapper").css('background', 'transparent');
    $('.loader-wrapper').addClass('blur-bg');
    $(".loader-wrapper").fadeIn(0);
}

window.end_loading_animation_M = function() {
    $('body').removeClass('wait');
    $(".loader-wrapper").stop(true, true).fadeOut(0);
    $('.loader-wrapper').removeClass('blur-bg');
    $(".loader-wrapper").css('background', 'linear-gradient(180deg, #1F253A 0%, #2071A7 100%)');
}
document.addEventListener("DOMContentLoaded", () => {


    window.addEventListener("beforeunload", function (event) {
        if(hasUnsavedChanges)
        {
          return;
        }
        if (!location.href.includes("import_wizard") && !location.href.includes("unsubscribes")) {
            start_loading_animation_M();
        }
    });

    window.addEventListener("load", function () {
        end_loading_animation_M();
    });

    $(document).ajaxSend(function (event, jqXHR, ajaxOptions) {
        start_loading_animation_M();
    });
    
    $(document).ajaxComplete(function () {
        end_loading_animation_M();
    });
    
    $(document).ajaxError(function () {
        end_loading_animation_M();
    });

    $(document).on('ajax:send', 'form[data-remote="true"]', function () {
        start_loading_animation_M();
    });
    
    $(document).on('ajax:complete ajax:error', 'form[data-remote="true"]', function () {
        end_loading_animation_M();
    });

    $(document).on('ajax:send', 'a[data-remote="true"]', function () {
        start_loading_animation_M();
    });

    $(document).on('ajax:complete ajax:error', 'a[data-remote="true"]', function () {
        end_loading_animation_M();
    });
    
  
});

document.addEventListener('DOMContentLoaded', function () {
    // Initialize tooltips
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
});

$(function () {
    $('[data-toggle="tooltip"]').tooltip();
});


document.addEventListener('DOMContentLoaded', function() {
  // Initialize all Select2 inputs
  function initializeSelect2() {
    $('.select2-input:not(.select2-manual)').each(function() {
      
      $(this).select2({
        theme: 'bootstrap-5',
        dropdownParent: $(this).parent(),
        placeholder: $(this).data('placeholder') || 'Select options',
        width: '100%'    
      });
      
    });
  }

  // Initialize on page load
  initializeSelect2();

  // Reinitialize after AJAX completions
  document.addEventListener("ajax:complete", initializeSelect2);
  document.addEventListener("turbo:load", initializeSelect2);
});

// Multiselect
document.addEventListener("DOMContentLoaded", function(event) {
    document.querySelectorAll(".multiselect").forEach(function(selectElement) {
      const labelText = selectElement.getAttribute("label") || "Select options"; // Get label or fallback text
  
      $(selectElement).multiselect({
        templates: {
          button: `<button type="button" class="multiselect dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><span class="multiselect-selected-text">${labelText}</span></button>`,
          filter: '<li class="multiselect-item multiselect-filter"><i class="fa fa-search text-secondary position-absolute" style="top: 16px;left: 15px;"></i><input class="form-control multiselect-search" type="text" /></li>',        
        },

        enableHTML: true,

        numberDisplayed: 0,
        enableCaseInsensitiveFiltering: true,
        includeFilterClearBtn: true,
        includeSelectAllOption: true,  // Enable the "Select All" option
        selectAllText: "Select All",   // Text for the "Select All" option
        enableFiltering: true,
        nonSelectedText: labelText,    // Use label text from each select element


        
      });
      
        $(selectElement).on("change", function () {
            var form = $(this).closest('form');
        
            form[0].requestSubmit();
        });

    });
});
  

document.addEventListener('DOMContentLoaded', function () {      
    jQuery(".best_in_place").best_in_place();
});

$(document).on('click', '.refresh-select2', function(e){
  if($(this).attr("data-refresh") == ""){
    let select2 = $(this).closest('.general_select2_container').find('.select2-input');
    select2.attr('id', 'item-' + Date.now());
    $(this).attr('data-refresh', select2.attr('id'))
  }
  $.ajax({
    type: 'GET',
    url: `/previews/refresh_select2?refresh=${$(this).attr("data-refresh")}&partial=${$(this).attr("data-partial")}&collection=${$(this).attr("data-collection")}`,
    dataType: 'script',
  }); 
})

$(document).on('click', '.global-go-to-selected', function(e){
  let select2 = $(this).closest('.general_select2_container').find('.select2-input');

  if(select2 == null || select2 == undefined || select2.val() == null || select2.val() == "")
    return

  if($(this).attr('data-objectName') == "Template"){
    url = "/editors/edit_responsive_template?id="+select2.val();
    window.open(url, '_blank').focus();
  }else if($(this).attr('data-objectName') == "Contact List"){
    url = "/general_contact_lists/"+select2.val();
    window.open(url, '_blank').focus();
  }
})

$(document).ready(function() {
    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
      return new bootstrap.Tooltip(tooltipTriggerEl);
    });
});



$(document).ready(function() {
    $('.summernote').each(function() {
      $(this).summernote({
        height: 300,
        dialogsInBody: true,
        placeholder: $(this).attr('placeholder'),
        toolbar: [
            ['style', ['style']],
            ['font', ['bold', 'underline', 'clear']],
            ['fontname', ['fontname']],
            ['color', ['color']],
            ['para', ['ul', 'ol', 'paragraph']],
            ['insert', ['link', 'picture']],
            ['view', ['fullscreen', 'codeview']]
        ],
          callbacks: {
            onImageUpload: function(files) {
                sendSummernoteFile($(this), files[0]);
            }
        }
        
      });
      $('.note-editor').css("width", "100%");
    });

});



$(document).ready(function() {
    var input = document.querySelectorAll('input');
    for (var i = 0; i < input.length; i++) {
        var placeholder = input[i].getAttribute('placeholder');
        if (placeholder) { // Ensure placeholder is not null or empty
            input[i].setAttribute('size', placeholder.length);
        }
    }
});


document.addEventListener('click', function () {
  // Sayfadaki tüm tooltip tetikleyicileri seç
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  
  tooltipTriggerList.forEach(function (tooltipTriggerEl) {
    const tooltipInstance = bootstrap.Tooltip.getInstance(tooltipTriggerEl);
    if (tooltipInstance) {
      tooltipInstance.hide();
    }
  });
});


document.addEventListener('DOMContentLoaded', function () {
  hasUnsavedChanges = false;
  // Takip edilecek inputları bul
  const trackedInputs = document.querySelectorAll('[data-track-changes="true"]');
  // Başlangıç değerlerini kaydet
  trackedInputs.forEach(input => {
    input.dataset.initialValue = input.value;
    // input değiştiğinde kontrol et
    input.addEventListener('input', () => {
      if (input.value !== input.dataset.initialValue) {
        hasUnsavedChanges = true;
      } else {
        // Değeri tekrar eski haline getirdiyse kontrol et
        hasUnsavedChanges = Array.from(trackedInputs).some(input =>
          input.value !== input.dataset.initialValue
        );
      }
    });
  });
  // Sayfa kapatılmadan önce uyarı göster
  window.addEventListener('beforeunload', function (e) {
    if (hasUnsavedChanges) {
      e.preventDefault();
      e.returnValue = '';
      return ''; // bazı tarayıcılarda gerekli
    }
  });
  // Form gönderilirse değişiklik kontrolünü kapat
  const forms = document.querySelectorAll('form');
  forms.forEach(form => {
    form.addEventListener('submit', function () {
      hasUnsavedChanges = false;
    });
  });
});